import React, { lazy, useEffect } from "react";
import Login from "src/containers/login";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "./PageLayout";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { Navigate } from "react-router";
import PageNotFound from "./PageNotFound";
import { PageStatusById } from "./ErrorBoundary";
import { useProfileServiceCenter } from "./useProfileServiceCenter";
import { useProfileAccount } from "./useProfileAccount";
import { useProfilePolicy } from "./useProfilePolicy";
import { useProfileProviders } from "./useProfileProviders";
import { useProfileTravel } from "./useProfileTravel";
// import { useProfileQuestionary } from "./useProfileQuestionary";
import { useProfileMedHistory } from "./useProfileMedHistory";
import { useProfileCompensations } from "./useProfileCompensations";
import { useProfilePersonalDoctors } from "./useProfilePersonalDoctors";
import { useProfileAppeals } from "./useProfileAppeals";
import { useProfileDoctor } from "./useProfileDoctor";
import actions from "src/store/common/actions";
import { routesSubroutes } from "../Breadcrumb";

export const PROFILE_PAGE_URL = "portal";
export const PROFILE_SERVICE_CENTER = "service-center";
export const PROFILE_ACCOUNT = "account";
export const PROFILE_POLICY = "policy";
export const PROFILE_PROVIDERS = "providers";
export const PROFILE_TRAVEL = "travel";
// export const PROFILE_QUESTIONARY = "questionary";
export const MED_HISTORY = "med-history";
export const PROFILE_COMPENSATIONS = "compensations";
export const PERSONAL_DOCTORS = "personal-doctor";
export const PROFILE_APPEALS = "appeals";
export const PROFILE_DOCTOR = "profile-doctor";

const Dashboard = lazy(() => import("src/containers/ProfileMain/index.js"));
import("profileCommon_mf/ImedilLoaderStyles");
export const PageLoadFailedComponent = () => (
  <PageStatusById id="common.PageLoadFailed" />
);
export const PageCrashedComponent = () => (
  <PageStatusById id="common.PageCrashed" />
);

const travelRoute = "/Purchase/TravelPolicyPurchase";

const Layout = () => {
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useSelector((state) => state.common.lang);

  const ServiceCenter = useProfileServiceCenter();
  const Account = useProfileAccount();
  const Policy = useProfilePolicy();
  const Providers = useProfileProviders();
  const Travel = useProfileTravel();
  // const Questionary = useProfileQuestionary();
  const MedHistory = useProfileMedHistory();
  const Compensations = useProfileCompensations();
  const PersonalDoctors = useProfilePersonalDoctors();
  const ProfileAppeals = useProfileAppeals();
  const ProfileDoctor = useProfileDoctor();

  const route = location.pathname;
  const langsArr = lang === "en" || lang === "ge";

  useEffect(() => {
    window.refreshWidgetVisibility();
  }, [loggedIn]);
  useEffect(() => {
    const lastSlashIndex = route.lastIndexOf("/");
    const splitRoute = route.substring(0, lastSlashIndex);
    const routeIsValid = routesSubroutes.hasOwnProperty(route);

    if (lang && langsArr && route !== travelRoute && loggedIn) {
      navigate(
        `${
          splitRoute === "" && !routeIsValid
            ? "/portal"
            : routeIsValid
            ? route
            : splitRoute
        }/${lang}`
      );
    }

    if (route === travelRoute) {
      const oid = location?.search?.split("=")?.[1];
      navigate(`/${PROFILE_TRAVEL}/${oid}/${lang}`);
    }
  }, [navigate, lang]);

  useEffect(() => {
    const parts = route.split("/");
    const lastPart = parts[parts.length - 1];
    const lastPartEqualLangs = lastPart === "en" || lastPart === "ge";

    if (lastPart !== lang && lastPart !== undefined && lastPartEqualLangs) {
      dispatch(
        actions.setLanguage(
          lastPartEqualLangs ? lastPart : localStorage.getItem("lang")
        )
      );
      if (lastPartEqualLangs) localStorage.setItem("lang", lastPart);
    }
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          loggedIn ? <PageLayout /> : <Navigate replace to={"/login/" + lang} />
        }
      >
        <Route
          index
          element={<Navigate replace to={`${PROFILE_PAGE_URL}/${lang}`} />}
        />
        <Route path={`${PROFILE_PAGE_URL}/${lang}`} element={<Dashboard />} />
        <Route
          path={`${PROFILE_SERVICE_CENTER}/${lang}`}
          element={<ServiceCenter />}
        />
        <Route path={`${PROFILE_ACCOUNT}/${lang}`} element={<Account />} />
        <Route path={`${PROFILE_POLICY}/${lang}`} element={<Policy />} />
        <Route path={`${PROFILE_PROVIDERS}/${lang}`} element={<Providers />} />
        <Route
          path={`${PROFILE_TRAVEL}/${lang}`}
          element={<Travel isFromClient={false} />}
        />
        {/* <Route
          path={`${PROFILE_QUESTIONARY}/${lang}`}
          element={<Questionary />}
        /> */}
        <Route path={`${MED_HISTORY}/${lang}`} element={<MedHistory />} />
        <Route
          path={`${PROFILE_COMPENSATIONS}/${lang}`}
          element={<Compensations />}
        />
        <Route
          path={`${PERSONAL_DOCTORS}/${lang}`}
          element={<PersonalDoctors />}
        />
        <Route
          path={`${PROFILE_APPEALS}/${lang}`}
          element={<ProfileAppeals />}
        />
        <Route path={`${PROFILE_DOCTOR}/${lang}`} element={<ProfileDoctor />} />
        <Route
          path="*"
          element={<Navigate replace to={`${PROFILE_PAGE_URL}/${lang}`} />}
        />
      </Route>
      <Route
        path={"login/" + lang}
        element={!loggedIn ? <Login /> : <Navigate replace to="/" />}
      />
    </Routes>
  );
};

export default Layout;
